import { ViewItemTitle } from '../../items/ViewItemTitle';
import type { ViewJSON, ViewModelJSON } from '../SearchResult/trpcSearchResultState';

type Props = {
  view: ViewJSON;
  viewModel: ViewModelJSON;
  searchKeyword?: string;
};

export const KataSearchViewItem: React.FC<Props> = ({ view, viewModel, searchKeyword }: Props) => {
  return (
    <div className="hover:bg-gray-300 focus:outline-none">
      <ViewItemTitle
        viewId={view.id}
        viewIsLocked={view.isLocked}
        viewName={view.name}
        viewModelId={viewModel.id}
        searchKeyword={searchKeyword}
      />
    </div>
  );
};
